<template>
  <form
    @submit.prevent="handleSubmit"
    ref="form"
    name="provider"
    class="row">
    <fieldset class="mt-20">
      <div
        v-for="(item, index) in inputs"
        :key="`provider-manage-field-${index}`">
        <!-- FIELDS -->
        <provider-fields
          v-if="item.type !== 'json'"
          :key="`field-${item.field}`"
          :field.sync="form[item.field]"
          :item="item"
          :submitted="submitted"
          :types="types"
          class="col-sm-4" />
        <!-- // FIELDS -->

        <!-- IF HAS SUBFIELDS -->
        <div
          v-if="item.type === 'json'"
          class="clearfix">
          <div class="col-sm-12">
            <h4>
              {{item.label}}&nbsp;&nbsp;
              <popover-item
                v-if="item.description.length"
                :text="item.description">
                <template slot:default><i class="fa fa-info-circle"></i></template>
              </popover-item>
            </h4>
          </div>
          <div class="clearfix">
            <div
              v-for="(subItem, subIndex) in item.fields"
              :key="`provider-manage-subfield-${subIndex}`"
              class="col-sm-4">
              <provider-fields
                :key="`field-${subItem.field}`"
                :field.sync="form[item.field][subItem.field]"
                :item="subItem"
                :submitted="submitted"
                :types="types" />
            </div>
          </div>
          <div class="col-sm-12 _mb-20">
            <hr class="border-bottom">
          </div>
        </div>
        <!-- // IF HAS SUBFIELDS -->
      </div>
    </fieldset>
    <fieldset class="clearfix">
      <div class="col-sm-8">
        <checkbox-field
          :submitted="submitted"
          :field.sync="form.active"
          :checked="form.active"
          value-label="ATIVO"
          name="active"
          class="mt-20" />
      </div>
      <div class="col-sm-4">
        <button
          :disabled="disabled"
          type="submit"
          class="btn-blue btn-block btn-extra-large">
          Atualizar
        </button>
      </div>
    </fieldset>
    <!-- <pre>
      {{form}}
    </pre> -->
  </form>
</template>

<script>
import PopoverItem from '@/components/ui/PopoverItem'
import CheckboxField from '@/components/fields/CheckboxField'
import ProviderFields from '@/views/dashboard/providers/ProviderFields'

export default {
  components: {
    PopoverItem,
    CheckboxField,
    ProviderFields
  },
  props: {
    loading: {
      type: Boolean,
      default: () => false
    },
    formFields: {
      type: Array,
      default: () => []
    },
    active: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      form: {},
      inputs: [],
      submitted: false,
      disabled: false,
      types: {
        text: ['char', 'decimal', 'integer', 'password', 'tel'],
        checkbox: ['boolean'],
        select: ['char list', 'list'],
        all: ['char', 'decimal', 'integer', 'boolean', 'char list', 'list', 'password', 'tel']
      }
      // exclude json -> form
    }
  },
  mounted () {
    this.handleForm()
  },
  methods: {
    async handleSubmit () {
      this.$validator.validate().then(valid => {
        this.submitted = true

        if (valid) {
          this.disabled = false
          this.$emit('handleAction', this.form)
        }
      }).catch(() => {
        /**/
        this.submitted = false
      })
    },

    handleForm () {
      this.handleFields()
      this.$set(this.form, 'active', this.active)
      this.inputs = [...this.formFields]
    },

    handleFields (form = this.form, formFields = this.formFields) {
      formFields.forEach(item => {
        if (['json'].indexOf(item.type) !== -1) {
          this.$set(form, item.field, {})
          this.handleFields(form[item.field], item.fields)
        } else {
          this.$set(form, item.field, item.value)
        }
      })
    }
  }
}
</script>
